import { createContext, useContext } from 'react';

export type FormatterFixedContext = { timezone: string; now?: string | number };

export const FormatterTimezoneContext = createContext<FormatterFixedContext | null>(null);

export const useFormatterTimezone = (): FormatterFixedContext | null =>
  useContext(FormatterTimezoneContext);
